import React from "react";

export default function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px" }}>
      <h1>Privacy Policy</h1>

      <p>
        Welcome to KaamHub. Your privacy is important to us. This Privacy Policy
        explains how we collect, use, and protect your personal information.
      </p>

      <h2>Information We Collect</h2>
      <ul>
        <li>Name</li>
        <li>Mobile Number</li>
        <li>Email Address</li>
        <li>Location</li>
        <li>Booking Details</li>
        <li>Payment Information</li>
      </ul>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To provide home services.</li>
        <li>To manage bookings.</li>
        <li>To improve customer support.</li>
        <li>To send important notifications.</li>
      </ul>

      <h2>Data Security</h2>
      <p>
        We use industry-standard security measures to protect your information.
      </p>

      <h2>Contact Us</h2>
      <p>Email: support@kaamhub.in</p>
      <p>Website: https://kaamhub.in</p>

      <p>Last Updated: July 2026</p>
    </div>
  );
}
